import React from "react";
import ServicesLayout from "../../../Utils/Serviceslayout/serviceslayout";
import { image } from "../../../Assets";

const TwoDtothreeDModelingService = () =>{
    return(
        <ServicesLayout mainservice="Modeling"  serviceName="2D(CAD/PDF) to 3D Modeling" 
        maincontent="Multi-disciplinary coordination - that of design, structure and building systems - can reveal complex, often unidentified buildability issues in a 3D environment. While the industry recognizes the numerous benefits, resource constraints mean that quite often the opportunity is not fully tapped." 
        content="Our specialized 2D drawing conversion to 3D modeling services enables all project stakeholders to collaborate in the most updated and digitized work environment. By transforming flat drawings into interactive 3D models, Fractile enhances work productivity and facilitates efficient communication and decision-making throughout the project lifecycle." 
        banner={image.twodto3d} banner2={image.twodto3d2}/>
    )
}   

export default TwoDtothreeDModelingService;